import { CarouselPortraitProgress, ModuleBase, QuoteElement } from '@/components';
import { ModuleBaseModel, ModuleBasePropsModel, QuoteModel } from '@/types';
import Flicking from '@egjs/react-flicking';
import { useRef } from 'react';

type QuoteCarouselModel = ModuleBaseModel<
  {
    quotes: QuoteModel[];
  } & ModuleBasePropsModel
>;

const QuoteCarousel = (data: QuoteCarouselModel) => {
  const {
    props: { quotes, backgroundColour },
  } = data;

  const carousel = useRef<Flicking>(null);

  return (
    <ModuleBase data={data}>
      <div className="container">
        <Flicking
          ref={carousel}
          preventClickOnDrag
          preventDefaultOnDrag
          align="center"
          horizontal
          panelsPerView={1}
          circular
          className="[&_.quote-element.no-image]:text-center [&_.quote-element.no-image_.quotee]:ml-0"
        >
          {quotes.map((quote, index) => (
            <QuoteElement key={index} quote={quote} backgroundColor={backgroundColour} />
          ))}
        </Flicking>
        <CarouselPortraitProgress className="mt-4 lg:mt-10" carousel={carousel} />
      </div>
    </ModuleBase>
  );
};

export default QuoteCarousel;
